<template>
  <div>
    <a-modal
      title="管理员设置"
      :maskClosable="false"
      v-model="visible"
      :footer="null"
      width="1000px"
    >
      <div class="header">
        <a-button
          v-if="user.IsVirtual"
          type="primary"
          @click="onAdd"
          class="button"
          >新增</a-button
        >
        <a-button
          v-if="user.IsVirtual"
          type="default"
          class="button"
          @click="onAdminPassword"
          >授权密码</a-button
        >
      </div>
      <a-table
        class="forcast-table"
        :columns="columns"
        :dataSource="data"
        :pagination="false"
        :loading="loading"
        bordered
        size="small"
        :scroll="scrollArray"
        :height="scrollArray.y"
        :style="{ 'min-height': scrollArray.y + 'px', 'margin-top': '10px' }"
      >
      </a-table>
    </a-modal>
    <a-modal
      title="新增管理员"
      :maskClosable="false"
      v-model="addVisible"
      width="600px"
    >
      <dataForm
        ref="dataForm"
        :colnum="1"
        :content="content"
        :labelCol="4"
        :wrapperCol="20"
        style="margin:20px 0;"
      >
      </dataForm>
      <template slot="footer">
        <a-button @click="onAddCancel">取消</a-button>
        <a-button type="primary" @click="onAddSubmit" :loading="addLoading"
          >确定</a-button
        >
      </template>
    </a-modal>
  </div>
</template>
<script>
import { cache } from "@/utils/common";
import { mapState } from "vuex";
import { cloneDeep } from "lodash";
import { DataForm } from "@/components/dataForm";
import promptModal from "@/components/promptModal";

export default {
  components: { DataForm },
  data() {
    return {
      visible: false,
      loading: false,
      scrollArray: { x: 700, y: 600 },
      user: {},
      data: [],
      columns: [
        {
          dataIndex: "UserName",
          width: 200,
          align: "center",
          title: "用户名称"
        },
        {
          dataIndex: "NickName",
          width: 200,
          align: "center",
          title: "微信名"
        },
        {
          dataIndex: "CompanyName",
          width: 200,
          align: "center",
          title: "门店名称"
        },
        {
          dataIndex: "CompanyCode",
          width: 120,
          align: "center",
          title: "门店编码"
        },
        {
          title: "操作",
          dataIndex: "Id",
          width: 120,
          align: "center",
          customRender: (text, record, index) => {
            if (text) {
              return [
                <a-button
                  size="small"
                  type="link"
                  {...{
                    on: {
                      click: () => {
                        this.onEdit(record, index);
                      }
                    }
                  }}
                >
                  编辑
                </a-button>,
                <a-button
                  size="small"
                  type="link"
                  {...{
                    style: "margin-left:10px",
                    on: {
                      click: () => {
                        this.onDelete(record, index);
                      }
                    }
                  }}
                >
                  删除
                </a-button>
              ];
            }
          }
        }
      ],
      content: [
        // {
        //   label: "门店",
        //   placeholder: "请输入证件号码",
        //   type: "select",
        //   name: "companyId",
        //   onChange: e => {
        //     var value = e.target.value;
        //     var res = this.$common.IdentityCodeValid(value);
        //     if (res) {
        //       this.$refs.otherForm.form.setFieldsValue({ BirthDate: res[1] });
        //     }
        //   }
        // },
        {
          label: "门店",
          placeholder: "请选择门店",
          type: "select",
          name: "CompanyId",
          option: {
            rules: [{ required: true, message: "请选择门店" }]
          },
          textField: "Name",
          valueField: "Id",
          onChange: (e, option) => {
            this.addData.CompanyId = e || 0;
            this.addData.CompanyCode = (option && option.Code) || "";
            this.addData.CompanyName = (option && option.Name) || "";
            this.onGetUser();
          }
        },
        {
          label: "用户",
          placeholder: "请选择用户",
          type: "select",
          name: "UserId",
          option: {
            rules: [{ required: true, message: "请选择用户" }]
          },
          textField: "Name",
          valueField: "Id",
          onChange: (e, option) => {
            this.addData.UserId = e || 0;
            this.addData.UserName = (option && option.Name) || "";
          }
        },
        {
          label: "备注",
          placeholder: "请输入备注",
          name: "Remark",
          type: "textarea",
          props: {
            rows: 2
          }
        }
      ],
      addData: {
        CompanyId: 0,
        CompanyCode: "",
        CompanyName: "",
        UserId: 0,
        UserName: "",
        Remark: "",
        LoginPassword: ""
      },
      addVisible: false,
      addLoading: false
    };
  },
  computed: {
    ...mapState({
      appConfig: state => state.app.appConfig
    })
  },
  created() {
    this.user = cache.get("user");
  },
  methods: {
    /**
     * @description: 显示
     * @return {*}
     */
    onShow() {
      this.visible = true;
      this.init();
    },
    /**
     * @description: 初始化
     * @return {*}
     */
    init() {
      this.loading = true;
      this.$post("GetLoginAdmin", {})
        .then(res => {
          this.data = res.Data.LoginAdmins;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 删除
     * @param {*} row
     * @param {*} index
     * @return {*}
     */
    onDelete(row, index) {
      let that = this;
      that.$confirm({
        title: "是否确认删除?",
        onOk() {
          that
            .$post("DeleteLoginAdmin", {
              id: row.UserId
            })
            .then(() => {
              that.$message.success("删除成功");
              that.data.splice(index, 1);
            });
        }
      });
    },
    /**
     * @description: 新增
     * @return {*}
     */
    onAdd() {
      this.addData.CompanyId = 0;
      this.addData.UserId = 0;
      this.addVisible = true;
      this.addLoading = true;
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields();
        this.onGetCompany().then(() => {
          this.addLoading = false;
        });
      });
    },
    /**
     * @description: 编辑
     * @param {*} row
     * @return {*}
     */
    onEdit(row) {
      this.addData = cloneDeep(row);
      this.addLoading = true;
      this.addVisible = true;
      this.$nextTick(() => {
        Promise.all([this.onGetCompany(), this.onGetUser()]).then(() => {
          this.addLoading = false;
          this.$refs.dataForm.setData(row);
        });
      });
    },
    /**
     * @description: 获取门店
     * @return {*}
     */
    onGetCompany() {
      return new Promise((resolve, reject) => {
        this.$post("Company_GetPageList", { PageSize: 999, PageIndex: 0 })
          .then(res => {
            let list = res.Data.Datas;
            this.$refs.dataForm.setFieldData("CompanyId", list);
            resolve();
          })
          .catch(() => {
            reject();
          });
      });
    },
    /**
     * @description: 获取门店用户
     * @return {*}
     */
    onGetUser() {
      return new Promise((resolve, reject) => {
        let id = this.addData.CompanyId;
        this.$refs.dataForm.setData({ userId: "" });
        if (id) {
          this.$post("GetCompanyUser", { id })
            .then(res => {
              let list = res.Data;
              this.$refs.dataForm.setFieldData("UserId", list);
              resolve();
            })
            .catch(() => {
              reject();
            });
        } else {
          this.$refs.dataForm.setFieldData("UserId", []);
          resolve();
        }
      });
    },
    /**
     * @description: 新增 || 编辑 提交
     * @return {*}
     */
    onAddSubmit() {
      this.$refs.dataForm.form.validateFields((err, values) => {
        if (!err) {
          this.$post("UpdateLoginAdmin", {
            ...this.addData,
            Remark: values.Remark
          }).then(() => {
            this.$message.success("新增成功");
            this.addVisible = false;
            this.init();
          });
        }
      });
    },
    onAdminPassword() {
      promptModal({
        title: "请输入密码",
        autoSelected: false,
        inputProps: {
          placeholder: "请输入密码",
          defaultValue: "",
          allowClear: true
        },
        beforeSubmit: val => {
          return new Promise((resolve, reject) => {
            if (!val) {
              this.$message.error("请输入正确的密码");
              reject();
            } else {
              resolve(true);
            }
          });
        },
        submit: val => {
          let loginPassword = val || "";
          this.$post("UpdateLoginAdmin", {
            userId: -1,
            loginPassword
          }).then(() => {
            this.$message.success("新增成功");
            this.addVisible = false;
            this.init();
          });
        }
      });
    },
    /**
     * @description: 新增 取消弹窗
     * @return {*}
     */
    onAddCancel() {
      this.addVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.photo-img {
  display: block;
  width: 100%;
}

.header .button {
  margin-right: 10px;
}
</style>
